import { Component, OnInit, OnDestroy, Input, Inject, ChangeDetectionStrategy } from '@angular/core';



import { ActivatedRoute } from '@angular/router';

import { AuthService } from '../../../services/auth/auth.service';

import { Router } from '@angular/router';

import { forkJoin, Subscription } from 'rxjs';


import { Pearl } from '../../../bo9-shared/models/pearl/pearl.model';
import { BO9UUID } from '../../../bo9-shared/models/UUID.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Person } from '../../../bo9-shared/models/person/person.model';
import { ArangoService } from '../../../services/arangoservice/arango.service';

@Component({
    selector: 'app-dialog-pearl',
    templateUrl: './pearlDialog.component.html',
    styleUrls: ['./pearlDialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PearlDialogComponent implements OnInit  {
  disableBtn = false;
  user: Person;
  subscriptions: Subscription[] = [];
  constructor(
    private dialogRef: MatDialogRef<PearlDialogComponent>,
    @Inject(MAT_DIALOG_DATA)  public data: { pearl: Pearl } ,

    private route: ActivatedRoute,
    private auth: AuthService,

    private arangoService: ArangoService,
    private router: Router,



   ) {
      console.log ('Init Pearl ' + JSON.stringify(data));
      this.user = this.auth.getAuthUser()!;
      this.subscriptions.forEach(s => s.unsubscribe());
      this.subscriptions.push(this.arangoService.recordVisit({
        page: this.router.url, component: 'PearlDialogComponent', 
        visitor: this.user._key,
        help: false
      }).subscribe ({next: () => {}})); 
     }

  ngOnInit() {

    console.log ('Init Pearl init ' + JSON.stringify(this.data));
    this.user = this.auth.getAuthUser()!;

    if (!this.user) {
      console.error('User Not logged in ');
      alert('EMail support&#64;bodyof9.com - Permission  Error #007'); 
      this.router.navigate(['login'] );
    }

  }


  deleteSelectPearl(p: Pearl ) {
    this.dialogRef.close(p);
  }

  close() {
    this.dialogRef.close();
  }
}
